var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdb-modal',{attrs:{"size":"sm","centered":"","show":_vm.visible}},[_c('mdb-modal-body',{staticClass:"d-flex flex-center"},[_c('mdb-spinner',{attrs:{"big":"","color":"yellow"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }